export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;

/** What keeps the Upload button off, in the order the form reads. */
export function uploadBlocker(
  file: { size: number } | null,
  sharedWith: number[],
): string | null {
  if (!file) return "Choose a file.";
  if (file.size > MAX_UPLOAD_BYTES) return "The file is larger than 100 MB.";
  if (sharedWith.length === 0)
    return "Share the file with at least one person.";
  return null;
}

/** The chosen people who may still be picked: checking Confidential, or moving the
 * file to a project, narrows the list, and nobody it leaves out stays chosen. */
export function keepAllowed(
  chosen: number[],
  allowed: { id: number }[],
): number[] {
  const ids = new Set(allowed.map((person) => person.id));
  return chosen.filter((id) => ids.has(id));
}

/** "Individual Files", "Payroll" or "Payroll / Plans". */
export function locationLabel(
  projectName?: string | null,
  collectionName?: string | null,
): string {
  if (!projectName) return "Individual Files";
  return collectionName ? `${projectName} / ${collectionName}` : projectName;
}
